<template>
  <RbuSectionPaginatedList
    :filter-options="filterOptions"
    :headers="headers"
    multi-rbut
    data-url="admin/rbu/section/"
    data-key="sections"
    :refresh-trigger.sync="innerRefreshTrigger"
    v-bind="$attrs"
    class="rbu-section-list"
    style="margin-top: 1rem"
  >
    <template v-slot:item.actions="{ item }">
      <div class="d-flex">
        <v-btn
          v-if="canShowAction(item) && canShowFreeze()"
          text
          color="primary"
          @click="freezeItem(item)"
        >
          {{ item.freeze ? "Unfreeze" : "Freeze" }}
        </v-btn>
        <v-btn
          v-if="canShowAction(item)"
          text
          color="primary"
          @click="editItem(item)"
        >
          More
        </v-btn>
        <v-btn
          v-if="canShowAction(item)"
          text
          color="primary"
          @click="editItemFluctuation(item)"
        >
          Fluctuation
        </v-btn>
        <v-btn
          text
          color="primary"
          v-if="
            $store.getters.hasPermission(PERMISSIONS.MANAGE_RBU_EDITION) &&
            canShowAction(item) &&
            canDeleteAndAddSection
          "
          @click="deleteItem(item)"
        >
          Delete
        </v-btn>
        <div v-if="!canShowAction(item)">
          <v-btn text color="primary" disabled>Freezed</v-btn>
        </div>
      </div>
    </template>
  </RbuSectionPaginatedList>
</template>

<script>
import { onMounted, ref, watch, computed } from "@vue/composition-api";
import RemotePaginatedList from "../RemotePaginatedList";
import { ACTION_TYPES } from "@/store/types";
import { PERMISSIONS, USER_TYPE } from "@/constants";
import RbuSectionPaginatedList from "../RbuSectionPaginatedList";

export default {
  name: "RbuSectionList",
  components: { RemotePaginatedList, RbuSectionPaginatedList },
  props: {
    value: Array,
    refreshTrigger: Boolean,
  },
  setup(props, { root, emit }) {
    const refresh = function () {
      innerRefreshTrigger.value = true;
    };
    const canDeleteAndAddSection = computed(() => {
      if (!root.$store.getters.account) return false;
      return [USER_TYPE.ADMIN, USER_TYPE.SUPER_ADMIN].includes(
        root.$store.getters.account.type
      );
    });
    onMounted(() => {
      refresh(false);
      // reset item table / filter
      root.$store.dispatch(ACTION_TYPES.RBU_ITEM_LIST_RESET_ALL);
    });

    watch(
      () => props.refreshTrigger,
      (newValue) => {
        if (newValue) {
          refresh(true);
          emit("update:refresh-trigger", false);
        }
      }
    );

    // Filter
    const filterOptions = ref([
      // { text: root.$t("rbu.edition"), value: "edition.id", contains: true },
    ]);

    // Data Table
    const headers = ref([
      { text: root.$t("rbu_section.order_no"), value: "order_no" },
      { text: root.$t("rbu_section.name"), value: "name" },
      { text: "", value: "actions", sortable: false, width: 100 },
    ]);
    const innerRefreshTrigger = ref(false);

    const editItem = async function (item) {
      root.$router.push({
        name: "rbu-section-detail",
        params: { sectionId: item.id },
      });
    };
    const editItemFluctuation = async function (item) {
      root.$router.push({
        name: "rbu-section-fluctuation",
        params: { sectionId: item.id },
      });
    };

    const freezeItem = async function (item) {
      if (await root.$dialog.confirm({ text: "Freeze RBU Section?" })) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/rbu/section/freeze_section/",
          params: { section_id: item.id },
        });

        if (response.body.success) {
          await refresh();
        }
      }
    };

    const deleteItem = async function (item) {
      if (await root.$dialog.confirm({ text: "Delete RBU Section?" })) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/rbu/section/delete/",
          params: { section_id: item.id },
        });

        if (response.body.success) {
          await refresh();
        }
      }
    };

    const canShowAction = function (item) {
      if (!item) return false;
      if (!root.$store.getters.account) return false;
      return (
        [USER_TYPE.ADMIN, USER_TYPE.SUPER_ADMIN].includes(
          root.$store.getters.account.type
        ) || !item.freeze
      );
    };

    const canShowFreeze = function () {
      if (!root.$store.getters.account) return false;
      return [USER_TYPE.ADMIN, USER_TYPE.SUPER_ADMIN].includes(
        root.$store.getters.account.type
      );
    };

    return {
      filterOptions,

      headers,
      innerRefreshTrigger,

      editItem,
      editItemFluctuation,
      deleteItem,

      PERMISSIONS,
      freezeItem,
      canShowAction,
      canShowFreeze,
      canDeleteAndAddSection,
    };
  },
};
</script>

<style lang="less"></style>
